import type { ReactNode } from "react";
import { Stack, Typography, styled, type StackProps } from "~/common/mui";
import { ControlInfo } from "./ControlInfo";
import type { ControlInfoViewModel } from "./controlViewModel";

export interface ControlFieldProps extends Omit<StackProps, "title"> {
  label: string;
  hideLabel?: boolean;
  info?: ControlInfoViewModel;
  helperText?: string;
  error?: boolean;
  errorText?: string;
  children: ReactNode;
}

const LabelRow = styled(Stack)({
  minWidth: 0,
  alignItems: "center",
});

const SupportingText = styled(Typography)(({ theme }) => ({
  paddingInline: theme.spacing(2),
  marginTop: theme.spacing(-0.5),
}));

export const ControlField = ({
  label,
  hideLabel = false,
  info,
  helperText,
  error = false,
  errorText,
  children,
  ...stackProps
}: ControlFieldProps) => {
  const supportingText = errorText ?? helperText;

  return (
    <Stack gap={1} alignItems={hideLabel ? "flex-start" : undefined} {...stackProps}>
      {!hideLabel ? (
        <LabelRow direction="row" gap={1}>
          <Typography variant="bodyLarge" color={error ? "error" : "textPrimary"}>
            {label}
          </Typography>
          {info ? <ControlInfo {...info} /> : null}
        </LabelRow>
      ) : null}
      {children}
      {supportingText ? (
        <SupportingText variant="bodySmall" color={error ? "error" : "textSecondary"}>
          {supportingText}
        </SupportingText>
      ) : null}
    </Stack>
  );
};
